module.exports = __webpack_public_path__ + "static/media/desktop-page-cover-layer-2.258d75e2.png";